import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Section from "../../layouts/Section";
import { downloadImage } from "../../utils/downloadImage";
import { Spinner } from "../Spinner";
import { Button, ButtonGroup } from "../ui/buttons/Button";

const FILE_TYPES = {
  PDF: "pdf",
  JPG: "jpg",
  JPEG: "jpeg",
  PNG: "png",
};

export const ViewRequestDocuments = ({ data, onClose }) => {
  const currentProgram = useSelector((s) => s.global.currentProgram);

  // managing documents
  const [prevDocuments, setPrevDocuments] = useState(
    data?.paymentReceiptsFileName.split(",")?.map((doc) => {
      return { preview: "", fileName: doc };
    }) || []
  );

  const updatePrevDocument = (document, index) => {
    // Clone the current state
    const newItems = [...prevDocuments];
    // Update the value at the specified index
    newItems[index] = {
      fileName: newItems[index]?.fileName,
      preview: document,
    };
    // Set the new state
    setPrevDocuments(newItems);
  };

  return (
    <>
      {/* previous documents */}
      <Section>
        <h6>
          Current Documents ({prevDocuments?.length ? prevDocuments?.length : 0}
          )
        </h6>
        {prevDocuments.length ? (
          <div className="document-list">
            {prevDocuments?.map((doc, index) => (
              <PrevDocumentItem
                file={doc}
                fileName={doc?.fileName}
                onSuccess={(document) => updatePrevDocument(document, index)}
              />
            ))}
          </div>
        ) : (
          <p className="alert alert-warning my-3">
            No previous documents found.
          </p>
        )}
      </Section>

      <ButtonGroup>
        <Button className="btn btn-light" text={"Close"} onClick={onClose} />
      </ButtonGroup>
    </>
  );
};

const PrevDocumentItem = ({ fileName, file, onSuccess, onRemove }) => {
  const PreviousDOcumentsQuery = useQuery(
    ["driver/payment/documents", fileName],
    () => downloadImage({ fileName: fileName }),
    {
      enabled: !!fileName,
      onSuccess: (res) => {
        const { data } = res;
        const filetype = fileName?.split(".").pop();

        let document = null;

        if (filetype === FILE_TYPES.PDF) {
          document = "data:application/pdf;base64," + data?.body;
        } else if (filetype === FILE_TYPES.PNG) {
          document = "data:image/png;base64," + data?.body;
        } else {
          document = "data:image/jpeg;base64," + data?.body;
        }
        onSuccess(document);
      },
    }
  );

  if (PreviousDOcumentsQuery.isLoading)
    return <Spinner text={"Fetching documents.."} />;

  return (
    <>
      <div className="document-item card mb-3">
        <div className="card-body d-flex align-items-center p-2">
          <div className="document-preview me-3">
            {file?.preview?.startsWith("data:image") ? (
              <img
                src={file.preview}
                alt="Preview"
                className="img-thumbnail"
                style={{ width: "80px", height: "80px" }}
                draggable={false}
              />
            ) : (
              <div className="document-icon">
                <span
                  role="img"
                  aria-label="document"
                  style={{ fontSize: "4rem" }}
                >
                  📄
                </span>
              </div>
            )}
          </div>
          <div className="document-info flex-grow-1">
            <p className="mb-2">{file?.name || file?.fileName}</p>
            <a href={file?.preview} download>
              Download
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
